module.exports = __webpack_public_path__ + "static/media/HP.561b4518.jpeg";